module.exports = __webpack_public_path__ + "img/0-1.b22c7736.png";